function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import { autoUpdate, flip, size as floatingSize, useFloating, useMergeRefs } from '@floating-ui/react';
export var useDropdownMenuProps = _ref => {
  var {
    ref,
    isOpen,
    shouldShowCreatableOption,
    getMenuProps,
    emptyState,
    closeMenu,
    resetHighlightedIndex,
    hasSections,
    options
  } = _ref;
  var {
    x,
    y,
    strategy,
    refs
  } = useFloating({
    whileElementsMounted: autoUpdate,
    middleware: [floatingSize({
      apply: _ref2 => {
        var {
          rects
        } = _ref2;
        refs.floating.current && Object.assign(refs.floating.current.style, {
          width: "".concat(rects.reference.width, "px")
        });
      }
    }), flip()]
  });

  var dropdownMenuProps = _objectSpread(_objectSpread({
    isOpen,
    x,
    y,
    strategy
  }, getMenuProps({
    ref: refs.setFloating
  }, {
    suppressRefError: true
  })), {}, {
    // Dropdown menu content props:
    contentProps: {
      shouldShowCreatableOption,
      emptyState,
      closeMenu,
      resetHighlightedIndex,
      hasSections,
      options
    }
  });

  return {
    anchorRef: useMergeRefs([ref, refs.setReference]),
    dropdownMenuProps
  };
};
//# sourceMappingURL=useDropdownMenuProps.js.map